import React from 'react';
import { Grid, TextField } from '@mui/material';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoNumerico: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange, onEnterKeyDown }) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            onEnterKeyDown?.();
            e.preventDefault();
        }
    };

    return (
        <Grid item xs={12} sm={12} md={6} key={indice.idIndice}>
            <TextField
                key={'TextFieldNumero-' + indice.idIndice}
                type="number"
                inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0 }}
                fullWidth
                label={indice.nomeIndice}
                placeholder={`Digite o ${indice.nomeIndice}`}
                disabled={disabled}
                value={valor ?? ''}
                onKeyDown={handleKeyDown}
                onChange={(event) => onChange(event.target.value)}
            />
        </Grid>
    );
};
